export enum FloatingButtonIcon {
    Check = 'Check',
    Edit = 'Edit',
    Print = 'Print',
}